import { FunctionComponent, h } from 'preact';
import classnames from 'classnames';

type Props = {
    className?: string;
};

export const Section: FunctionComponent<Props> = ({ children, className, ...props }) => {
    return (
        <section className={classnames('l-section u-flex-center', className)} {...props}>
            <div className="l-container">{children}</div>
        </section>
    );
};
